import { ReactComponent as ComingSoonImage } from '../../assets/coming-soon.svg';

type CommingSoonProps = {
    size?: 'small' | 'regular';
};
function CommingSoon({ size = 'regular' }: CommingSoonProps): JSX.Element {
    return (
        <div className="flex flex-col items-center">
            <ComingSoonImage className={`${size === 'regular' ? '' : 'h-56 w-56'}`} />
            <p className={`${size === 'regular' ? ' text-4xl' : 'text-lg'} mt-2 font-bold tracking-tight text-gray-900`}>Coming soon</p>
            <p className={`${size === 'regular' ? 'text-base' : 'text-sm'} mt-2 text-gray-500`}>
                This isn&apos;t quite ready yet, but we&apos;re working on it!
            </p>
            <div className="mt-4">
                <a
                    href="https://trello.com/b/xR5wENTP/cimplico-workpapers-roadmap"
                    target="_blank"
                    className={`${size === 'regular' ? 'text-base' : 'text-sm'} font-medium text-indigo-600 hover:text-indigo-500`}
                    rel="noreferrer"
                >
                    Follow our progress
                    <span aria-hidden="true"> &rarr;</span>
                </a>
            </div>
        </div>
    );
}
export default CommingSoon;
